'use strict';

import {reductionModel} from "../../models/reductionmodel.js";

export class ProjectReductionCtrl
{
	model;

	classif;

	attachments = [];

	uploadTs = 0;

	$filter;

	constructor($scope, $http, $filter, $timeout, $mdDialog, notify, jsDataService){
		this.$scope = $scope;
		this.$http = $http;
		this.$filter = $filter;
		this.$timeout = $timeout;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
//		this.model = jsDataService.get('reduction');
		this.classif = jsDataService.get('cfgClassif');
		this.model = new reductionModel(jsDataService.get('reduction'), $filter, this.jsDataService);

		this.calcAmount();
	}

	autosavePostFields() {
		let postData = this.model.getData();
		if(this.model.date_cet instanceof Date){
			postData.date = this.$filter('date')(this.model.date_cet, 'yyyy-MM-dd');
		}
		else{
			postData.date = 0;
		}
		const data = {
			date: postData.date,
			amount: this.model.amount,
			comment: this.model.comment,
			section_1_attachment: this.model.section_1_attachment,
			beneficiaries: this.model.beneficiaries
		};

		return data;
	}

	modelValue(name){
		if(typeof(this.model) !== 'undefined'){
			return this.model.getValue(name);
		}
		return '';
	}

	fieldFormat(model){
		if(typeof(model.amount) === 'undefined'){
			model.amount = null;
		}
		if(model.amount){
			const strVal = new String(model.amount);
			model.amount = parseInt(strVal.replace(/[^0-9]/, '').replace(/^0/g, '').valueOf());
		}
	}

	onAttachmentUpload(field, file){
		if(field === 'section_1'){
			this.model.section_1_attachment.push({title: file.file_name, file_id: file.file_id});
		}
//		this.$scope.editForm['upload_ts'].$setViewValue(Date.now());
//		this.uploadTs = Date.now();
//		this.model.section_1_attachment.push({id: 1, title: 'testx', file_id: 77});
	}

	onAttachmentRemoved(field, attachment){
//		const index = this.model.section_1_attachment.indexOf(attachment);
//
//		if(index === -1){
//			return;
//		}
//		console.log(index);
//		this.model.section_1_attachment.splice(index, 1);
//		console.log(this.model.section_1_attachment);
//		this.$scope.editForm['upload_ts'].$setViewValue(Date.now());
	}

	calcAmount(){
		let grandTotal = 0;
		if(typeof(this.model.beneficiaries) !== 'undefined' && this.model.apply_reduction_to_participants>0){
			for(let r in this.model.beneficiaries){
				grandTotal += this.model.beneficiaries[r].amount;
			}
			this.model.amount = grandTotal;
		}
	}

	complete(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			if(form.$invalid){
				this.notify(this.$filter('tr')('err_check_required_fields'), true);
			}
			else{
				const confirmTexts = this.jsDataService.get('reductionConfirmTexts');
				const confirm = this.$mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.cancel(confirmTexts.cancel);
				this.$mdDialog.show(confirm).then(() => {
					this.$scope.basicHttpConfigProcess({
						url: this.jsDataService.get('cfgConfirmUrl'),
						method: 'GET',
						params: {}
					}).then((results) => {
						if(results.data.success){

						}
					});
				}, () => {});
			}
		});
	}

	cancel(ev){
		const confirmTexts = this.jsDataService.get('reductionCancelTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgCancelUrl'),
				method: 'GET',
				params: {}
			}).then((results) => {
				if(results.data.success){

				}
			});
		}, () => {});

	}

	remove(ev){
		const confirmTexts = this.jsDataService.get('removeConfirmTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgRemoveUrl'),
				method: 'GET',
				responseType: 'json'
			}).then((results) => {
				if(results.data.success){

				}
			});
		}, () => {});

	}

	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
}